import React from 'react';

/**
 * Loader do PageLoader: o símbolo da Astrolink "respirando".
 * O estilo (imagem + animação breathe) é FONTE ÚNICA em `Astrolink/website/css/pageloader.css`
 * (classe `.pageloader-logo`), linkado no `_heads.php` do legado — o mesmo CSS estiliza o
 * overlay crítico de fade-out da chegada. Decorativo (o overlay já anuncia o loading via ARIA).
 */
const AstroLoader = () => <span className="pageloader-logo" aria-hidden="true" />;

export default AstroLoader;
